var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"flex items-center py-5 text-gray-800",attrs:{"to":{ name: 'editMolecule', params: { moleculeId: _vm.molecule.id } },"tag":"div","active-class":"font-bold"}},[_c('h3',[_vm._v(" "+_vm._s(_vm.molecule.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }